const getDescopeUiComponentsList = (template) => [
    ...Array.from(template.content.querySelectorAll('*')).reduce((acc, el) => el.localName.startsWith('descope-') ? acc.add(el.localName) : acc, new Set()),
];

export { getDescopeUiComponentsList };
//# sourceMappingURL=helpers.js.map
